<template>
  <Sidebar :width="500" id="customer-payment-sidebar" title="Payment" right>
    <div class="px-3 py-1">
      <b-card class="my-2">
        <b-row>
          <b-col cols="12" class="mb-2">
            <b-input-group prepend="Date" size="sm" class="mb-2">
              <b-form-datepicker
                :button-content-state="false"
                v-model="payment.date_time"
                size="sm"
              ></b-form-datepicker>
            </b-input-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" class="form-group">
            <div>
              <div class="text-left font-poppins mb-2">
                {{ payment.payment_type }}
              </div>
              <b-input-group size="md">
                <b-input-group-prepend>
                  <b-form-select
                    size="sm"
                    v-model="payment.payment_type"
                    :options="paymentOptions"
                  ></b-form-select>
                </b-input-group-prepend>
                <b-form-input
                  placeholder="Amount"
                  type="number"
                  v-model="payment.amount"
                  size="sm"
                ></b-form-input>
              </b-input-group>
              <b-row v-show="payment.payment_type == 'Card'" class="mt-2 mb-4">
                <b-col cols="12" class="mb-2">
                  <b-input-group prepend="Bank" size="sm" class="mb-2">
                    <b-form-input
                      type="text"
                      v-model="payment.card_bank"
                      size="sm"
                    ></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row>
              <b-row
                v-show="payment.payment_type == 'Cheque'"
                class="mt-2 mb-4"
              >
                <b-col cols="12">
                  <b-card>
                    <b-row>
                      <b-col cols="12" class="mb-2">
                        <b-input-group prepend="Number" size="sm" class="mb-2">
                          <b-form-input
                            type="number"
                            v-model="payment.cheque_no"
                            size="sm"
                          ></b-form-input>
                        </b-input-group>
                      </b-col>
                      <b-col cols="12" class="mb-2">
                        <b-input-group prepend="Date" size="sm" class="mb-2">
                          <b-form-datepicker
                            :button-content-state="false"
                            v-model="payment.cheque_date"
                            size="sm"
                          ></b-form-datepicker>
                        </b-input-group>
                      </b-col>
                      <b-col cols="12" class="mb-2">
                        <b-input-group prepend="Bank" size="sm" class="mb-2">
                          <b-form-input
                            type="text"
                            v-model="payment.cheque_bank"
                            size="sm"
                          ></b-form-input>
                        </b-input-group>
                      </b-col>
                      <b-col cols="12" class="mb-2">
                        <b-input-group prepend="Type" size="sm" class="mb-2">
                          <b-form-select
                            size="sm"
                            v-model="payment.cheque_type"
                            :options="chequeTypes"
                          >
                          </b-form-select>
                        </b-input-group>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
              <div class="mt-2">
                <label for="formGroupExampleInput" class="d-block"
                  >Payment Note</label
                >

                <b-form-textarea
                  rows="3"
                  max-rows="6"
                  v-model="payment.remarks"
                  placeholder="Type something"
                  size="sm"
                  class="mb-2"
                ></b-form-textarea>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-card>

      <b-row>
        <b-col cols="12">
          <b-button
            @click="Payment()"
            block
            variant="primary"
            class="pt-3 pb-3 font-poppins font-weight-bold w-100"
          >
            <b-spinner
              v-if="loading"
              variant="primary"
              label="Spinning"
            ></b-spinner>
            <div v-else>Submit</div>
          </b-button>
        </b-col>
      </b-row>
    </div>
  </Sidebar>
</template>

<script>
import _ from "lodash";
import { mapState, mapGetters } from "vuex";
import Sidebar from "@/components/base/Sidebar";

export default {
  name: "Payment",
  components: {
    Sidebar,
  },
  data: () => ({
    paymentOptions: ["Cash", "Card", "Cheque", "Other"],
    chequeTypes: ["Cash", "Cross"],
    loading: false,
    payment: {
      date_time: null,
      amount: 0,
      payment_type: "Cash",
      remarks: "",
    },
  }),

  computed: {
    ...mapState("sales", ["sales_info"]),
    ...mapGetters("bill", ["GetTotalAmount", "GetServiceTotalAmount"]),
  },

  methods: {
    isValid() {
      this.$v.$touch();

      let status = false;

      status = !this.$v.$invalid;

      if (status) {
        return true;
      } else {
        return false;
      }
    },
    Payment() {
      this.loading = true;
      this.$store
        .dispatch("bill/submitSalePayment", {
          id: this.sales_info.id,
          payment: this.payment,
        })
        .then((res) => {
          this.loading = false;
          if (res.status == 200) {
            // ✅ Don't reset payment here. Instead prepare print snapshot.
            this.$store.commit("bill/SET_BILL_PRODUCTS_TO_PRINT_DATA");

            // Optionally reset only the local form input fields
            this.payment = {
              date_time: null,
              amount: 0,
              payment_type: "Cash",
              remarks: "",
            };

            this.showToast("Payment successfully updated", "Success");
          } else {
            this.showToast("Sales Failed", "danger");
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // Payment() {
    //   // ;
    //   if (this.GetTotalAmount + this.GetServiceTotalAmount == 0) {
    //     return;
    //   }

    //   this.loading = true;
    //   // Amount validation checks
    //   this.amountState = null;

    //   if (this.GetSaleType == 'Cash') {
    //     if (
    //       this.GetTotalAmount + this.GetServiceTotalAmount !=
    //       this.addedAmountTotal
    //     ) {
    //       this.amountState = false;
    //       this.loading = false;
    //       return;
    //     } else {
    //       this.amountState = true;
    //     }
    //   }

    //   var payments = [];
    //   for (var x = 0; x < this.payments.length; x++) {
    //     payments[x] = _.cloneDeep(this.payments[x]);
    //     delete payments[x].haveNote;
    //   }

    //   this.$store
    //     .dispatch('bill/submitSale', payments)
    //     .then((res) => {
    //       this.loading = false;
    //       if (res.status == 200) {
    //         this.tab = 1;

    //         this.$store.commit('bill/SET_BILL_PRODUCTS_TO_PRINT_DATA');
    //         this.payments = [
    //           {
    //             amount: 0,
    //             payment_type: 'Cash',
    //             haveNote: false,
    //             payment_note: '',
    //           },
    //         ];

    //         this.$store.dispatch('shops/fetchCashflowData');
    //       } else {
    //         this.showToast('Sales Failed', 'Success');
    //       }
    //     })
    //     .catch((err) => {
    //       this.loading = false;
    //     });
    // },
    showToast(message, variant = null) {
      this.$bvToast.toast(message, {
        title: "Message",
        variant: variant,
        solid: true,
      });
    },
  },
};
</script>

<style>
.total_amount_area {
  background: #063232;
  color: white;
  border: unset !important;
}

.total_discount_area {
  background: #0d6666;
  color: white;
  border: unset !important;
}

.total_discount_area span {
  font-size: 14px;
}

.subtotal_area {
  background: #13928e;
  color: white;
  border: unset !important;
}

.subtotal_area span {
  font-size: 14px;
}
</style>
